import { TSelectOption } from 'shared/types'
import { FOLLOWED_FILTER_VALUES } from 'shared/consts/filter'
import { IUser } from 'shared/interfaces'

export const filterFollowOptions = (options: TSelectOption[], isMyOptionShown: boolean) =>
  isMyOptionShown ? options : options.filter((option) => option.value !== FOLLOWED_FILTER_VALUES.MY)

export const formatUserList = (users: IUser[]) =>
  users.map(({ id, last_name, first_name, unit_id }) => ({
    value: id,
    label: `${first_name} ${last_name}`,
    unit_id
  }))
